import posthog from "posthog-js";

export const trackSignUp = (username: string) => {
  posthog.capture("signed_up", {
    username,
  });
};
